import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import ButtonBase from '@material-ui/core/ButtonBase';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import { SessionContext } from "../context/session-context";

import conservationLegend from '../assets/legends/Conservation_legend.png';
import firestationLegend from '../assets/legends/Firestation_legend.png';
import floodmapLegend from '../assets/legends/Floodmap_legend.png';
import groundwaterLegend from '../assets/legends/GroundwaterFlooding_legend.png';
import inspirePolygonLegend from '../assets/legends/InspirePolygon_legend.png';
import listedBuildingLegend from '../assets/legends/ListedBuilding_legend.png';
import radonLegend from '../assets/legends/Radon_Indicative_Atlas.png';
import riverCoastalFloodingLegend from '../assets/legends/RiverCoastalFlooding_legend.png';
import soilmapLegend from '../assets/legends/Soilmap_legend.png';

const productLegends = {
    lr_inspirepolygons: [inspirePolygonLegend],
    listed_buildings: [listedBuildingLegend],
    conservation_area: [conservationLegend],
    bgs_groundwater: [groundwaterLegend],
    bgs_flooding: [riverCoastalFloodingLegend],
    ea_floodzones: [floodmapLegend],
    fire_stations: [firestationLegend],
    landis_nationalsoilmap: [soilmapLegend],
    radon_indicative_atlas: [radonLegend],
    radon_potential: [radonLegend],
};

export default function LayerProductCard(props) {
    const useStyles = makeStyles({
        productItem: {
            color: '#000',
            background: '#fff',
            padding: '5px 5px 5px 20px',
            borderBottom: '1px solid #D2D2D8',
            width: 285,
            marginBottom: 0,
            '& .MuiOutlinedInput-root':{
                height:20
            }
        },
        legendImageButton: {
            background: 'none',
            border: 0,
            cursor: 'zoom-in',
            display: 'block',
            marginTop: 5,
            padding: 0,
            textAlign: 'left',
            width: '100%',
        },
        legendImage: {
            display: 'block',
            height: 'auto',
            maxWidth: '60%',
            width: '60%',
        },
        enlargedLegend: {
            display: 'block',
            height: 'auto',
            margin: '0 auto',
            maxHeight: '85vh',
            maxWidth: '100%',
            width: 'auto',
        },
        enlargedLegendClose: {
            position: 'absolute',
            right: 8,
            top: 8,
        },
        productLabel:{
            marginTop: 5,
            marginBottom: 5
        },
        productLabelDisabled:{
            marginTop: 5,
            marginBottom: 5,
            color: 'rgba(0, 0, 0, 0.12)',
        },
        productFormat:{
            minWidth: 100
        },
        textItemFont:{
            fontSize:11
        },
        productSelectButton: {
            marginLeft: 35,
            marginTop: 0,
            '& .Mui-selected':{
                color:'#fff',
                background:'#0C4C35'
            }
        },
        editButton:{
            height: 32,
            width: 32,
            minWidth: 32,
            padding: 0
        }
    });

    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }))(Tooltip);

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [productcode, setProductcode] = useState(props.productcode);
  const [geoserverLayer, setGeoserverLayer] = useState(props.item.layer);
  const [selected, setSelected] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [tooltip, setTooltip] = useState('');
  const [layerDisplayed, setLayerDisplayed] = useState(false);
  const [enlargedLegend, setEnlargedLegend] = useState(null);

  useEffect(() => { 
    const eLayer = sState.dlayer;
    const index = eLayer.indexOf(productcode)
    if (index > -1) { setSelected(true); setLayerDisplayed(true); }
 },[])

  useEffect(() => { 

    if (!layerDisplayed && selected){
        //console.log("Layer selected. "+layerDisplayed+" "+selected+" "+productcode);

        const change = {layer:productcode, geoserver:geoserverLayer, action:'add'}
        sDispatch({ type: "setDataLayerChange", payload: { layerChange : change} });
        setLayerDisplayed(true);

        const eLayer = sState.dlayer;
        eLayer.push(productcode);
        sDispatch({ type: "setDataLayer", payload: { layers : eLayer} });

        updateTooltip();
    } else {
        removeDisplayLayer();
    }
  },[selected])

  useEffect(() => { 
    if (parseInt(sState.viewScale) >= parseInt(props.item.minScale) && parseInt(sState.viewScale) <= parseInt(props.item.maxScale)){
        setDisabled(false);
        updateTooltip();
    } else {

        //Removes the layer if currently displayed.
        if (selected) { setSelected(false); }
        setDisabled(true);
        setTooltip('Not available at current view scale');
    }
    
  },[sState.viewScale])

  const updateTooltip = () =>{
      setTooltip(selected ? 'Remove layer' : props.tooltip);
  };

  const removeDisplayLayer = () =>{
    if (sState.dlayerChange.layer !== ''){
        //console.log("Layer deselected. "+layerDisplayed+" "+selected+" "+productcode)
        const change = {layer:productcode, geoserver:geoserverLayer, action:'remove'}
        sDispatch({ type: "setDataLayerChange", payload: { layerChange : change} });
        setLayerDisplayed(false);

        const eLayer = sState.dlayer;
        const index = eLayer.indexOf(productcode)
        if (index > -1) { eLayer.splice(index, 1) }
        if (index === -1) { sDispatch({ type: "setDataLayer", payload: { layers : eLayer} }); setLayerDisplayed(false);}
    }

  }

  return (
    <>
        <div className={classes.productItem}>
            <Grid container>
                <Grid item xs={9}>
                    <Grid container>
                        <HtmlTooltip title={<React.Fragment>{props.item.tooltip}</React.Fragment>}>
                            <Grid item xs={12}><Box className={disabled ? classes.productLabelDisabled : classes.productLabel} fontWeight="fontWeightBold" fontSize={12}>{props.item.productname}</Box></Grid>
                        </HtmlTooltip>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <Box className={classes.productSelectButton} >
                    <HtmlTooltip title={<React.Fragment>{tooltip}</React.Fragment>}>
                        <span><ToggleButton className={classes.editButton} value="selected" selected={selected} disabled={disabled} onChange={() => {setSelected(!selected)} } > {selected ? ( <CheckIcon />) : ( <AddIcon /> )} </ToggleButton></span>
                    </HtmlTooltip>
                    </Box>
                </Grid>
            </Grid>
            {selected && productLegends[productcode]?.map((legend, legendIndex) => (
                <ButtonBase
                    className={classes.legendImageButton}
                    onClick={() => setEnlargedLegend({ src: legend, alt: `${props.item.productname} legend` })}
                    aria-label={`Enlarge ${props.item.productname} legend`}
                    key={legendIndex}
                >
                    <img className={classes.legendImage} src={legend} alt="" />
                </ButtonBase>
            ))}
        </div>
        <Dialog
            open={Boolean(enlargedLegend)}
            onClose={() => setEnlargedLegend(null)}
            maxWidth="lg"
            fullWidth
            aria-label="Enlarged legend image"
        >
            {enlargedLegend && (
                <DialogContent>
                    <IconButton
                        className={classes.enlargedLegendClose}
                        onClick={() => setEnlargedLegend(null)}
                        aria-label="Close enlarged legend"
                    >
                        <CloseIcon />
                    </IconButton>
                    <img className={classes.enlargedLegend} src={enlargedLegend.src} alt={enlargedLegend.alt} />
                </DialogContent>
            )}
        </Dialog>
    </>

  );
}